var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getShow)?_c('div',{staticClass:"ibx-app-notification__view-only"},[_c('div',{staticClass:"ibx-app-notification__view-only-text"},[_c('span',[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"ibx-app-notification__view-only-close",on:{"click":_vm.onClickClose}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'times']}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }